import React from 'react';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';

export default function CourseDetail() {
  return (
    <div className="min-h-screen bg-[#1b1b1b] text-[#dedede] font-['Inter',sans-serif] antialiased overflow-x-hidden">
      <Header />

      {/* Hero */}
      <section className="relative min-h-[500px] flex items-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.pexels.com/photos/29136672/pexels-photo-29136672/free-photo-of-luxurious-car-interior-with-digital-dashboard.jpeg"
            alt="Категория B"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1b1b1b] via-[#1b1b1b]/70 to-transparent" />
          <div className="absolute inset-0 bg-black/30" />
        </div>

        <div className="relative z-20 max-w-screen-2xl mx-auto px-8 text-center">
          <span className="text-[11px] font-black uppercase tracking-[0.5em] text-primary mb-4 block">
            Популярный
          </span>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter mb-4">
            Категория B
          </h1>
          <p className="text-xl md:text-2xl text-[#dedede] mb-8">
            Автоматическая коробка передач
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <span className="bg-white/5 border border-white/10 px-6 py-3 rounded-full backdrop-blur-md text-sm uppercase tracking-widest">
              3 месяца
            </span>
            <span className="bg-white/5 border border-white/10 px-6 py-3 rounded-full backdrop-blur-md text-sm uppercase tracking-widest">
              АКПП
            </span>
            <span className="bg-white/5 border border-white/10 px-6 py-3 rounded-full backdrop-blur-md text-sm uppercase tracking-widest">
              Теория онлайн
            </span>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#1b1b1b]">
        <div className="max-w-screen-2xl mx-auto px-8">
          <p className="text-xl md:text-2xl text-[#dedede] font-light max-w-4xl mx-auto leading-relaxed mb-16 text-center">
            Полный курс обучения вождению на легковых автомобилях с автоматической коробкой передач. 
            Включает 134 часа теории и 56 часов практики в реальных городских условиях.
          </p>

          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-12 text-center">
            Этапы обучения
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { num: '1', title: 'Теория ПДД', desc: 'Онлайн-лекции по правилам дорожного движения.' },
              { num: '2', title: 'Медицина и безопасность', desc: 'Первая помощь и основы безопасности.' },
              { num: '3', title: 'Практика вождения', desc: 'Вождение на автодроме и в городе с инструктором.' },
              { num: '4', title: 'Получение прав', desc: 'Сдача экзамена в ГИБДД и выдача удостоверения.' },
            ].map((stage) => (
              <div key={stage.num} className="glass-card rounded-[28px] p-8 flex flex-col items-center text-center">
                <div className="w-12 h-12 bg-primary flex items-center justify-center rounded-full text-white font-black mb-6">
                  {stage.num}
                </div>
                <h3 className="text-2xl font-black uppercase tracking-tight mb-4">
                  {stage.title}
                </h3>
                <p className="text-slate-400 leading-relaxed">
                  {stage.desc}
                </p>
              </div>
            ))}
          </div>

          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mt-24 mb-12 text-center">
            Ваш инструктор
          </h2>

          <div className="glass-card rounded-[28px] p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 max-w-2xl mx-auto">
            <img
              src="https://www.shutterstock.com/image-photo/driving-instructor-teaching-his-student-260nw-781124311.jpg"
              alt="Инструктор"
              className="w-32 h-32 rounded-full object-cover"
            />
            <div className="text-center md:text-left">
              <h3 className="text-3xl font-black uppercase tracking-tight mb-4">
                Алексей Иванов
              </h3>
              <p className="text-slate-400 mb-4">
                Стаж 12 лет • Toyota Camry
              </p>
              <div className="flex justify-center md:justify-start items-center gap-2 mb-4">
                <span className="text-yellow-400 text-2xl">★★★★★</span>
                <span className="font-bold">5.0</span>
              </div>
              <div className="flex flex-wrap justify-center md:justify-start gap-4">
                <span className="bg-white/5 border border-white/10 px-6 py-3 rounded-full backdrop-blur-md text-sm uppercase tracking-widest">
                  Спокойный
                </span>
                <span className="bg-white/5 border border-white/10 px-6 py-3 rounded-full backdrop-blur-md text-sm uppercase tracking-widest">
                  Профи
                </span>
              </div>
            </div>
          </div>

          <div className="fixed bottom-16 left-4 right-4 z-50 md:static md:mt-16 md:max-w-md md:mx-auto">
            <button className="w-full px-10 py-6 bg-primary text-white font-black rounded-full neon-glow-red uppercase tracking-widest text-lg hover:shadow-[0_0_60px_rgba(225,29,72,0.4)] transition-all">
              29 900 ₽ Записаться →
            </button>
          </div>
        </div>
      </section>

      <BottomNav />
    </div>
  );
}